import {
  SET_SDK_APP_ID,
  SET_USER_SIG,
  SET_PLAYER_DOMAIN,
  SET_ROOM_ID,
  SET_ROOM_NAME,
  UPDATE_USER_INFO,
  SET_ANCHOR_USER_ID,
  SET_IS_SUPPORT_WEBRTC,
  UPDATE_LINE_TYPE,
  UPDATE_SEND_MSG_ENABLE,
  UPDATE_CHAT_ROOM_ENABLE,
  UPDATE_LIVE_INFO,
  SET_PLAY_URL,
} from '@/constants/mutation-types';

export default {
  setPlayUrl({ commit }, value) {
    commit(SET_PLAY_URL, value);
  },
};
